import React from 'react'
import PropTypes from 'prop-types'
import Head from 'next/head'
import { getAttributesFromHtml } from '../../../common/helpers'
import { IFrames } from '../RichText/components/embeddedEntryComponents'

const IFramePageLayout = ({ script, content }) => {
  let scriptAttributes = {}
  if (script) {
    scriptAttributes = getAttributesFromHtml(script)
  }

  return (
    <div
      className="mx-auto mb-16 max-w-screen-lg border-t xl:px-0"
      data-testid="iframe-page-layout"
    >
      {script ? (
        <Head>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <script {...scriptAttributes} />
        </Head>
      ) : null}

      <IFrames content={content} />
    </div>
  )
}

IFramePageLayout.defaultProps = {
  script: '',
}

IFramePageLayout.propTypes = {
  script: PropTypes.string,
  content: PropTypes.string.isRequired,
}
export default IFramePageLayout
